var map = {
	"./$GMUSIC-icon.png": 1546,
	"./BAT-icon.png": 1547,
	"./BTC-icon.png": 1548,
	"./BXC-icon.png": 1549,
	"./CC-icon.png": 547,
	"./DistTest-icon.png": 1550,
	"./ETH-icon.png": 1551,
	"./GALA-icon.png": 1030,
	"./GALA[ETH]-icon.png": 1552,
	"./GALA[GYRI]-icon.png": 1553,
	"./MTRM-icon.png": 1554,
	"./NODETESTCOIN-icon.png": 1555,
	"./SILK-icon.png": 1556,
	"./SILK[GYRI]-icon.png": 1557,
	"./TANK-icon.png": 1558,
	"./TCTESTCOIN-icon.png": 1559,
	"./TEST-icon.png": 1560,
	"./TOWN-icon.png": 1561,
	"./coinpayments-icon.png": 1562,
	"./mastercard-icon.png": 545,
	"./simplex-icon.png": 1049,
	"./visa-icon.png": 546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 656;